export const getFieldOwner = (field) => {
  const { agronomistDetails, farmerDetails } = field;

  if (Array.isArray(farmerDetails) && farmerDetails.length) {
    return farmerDetails[0];
  } else if (Array.isArray(agronomistDetails) && agronomistDetails.length) {
    return agronomistDetails[0];
  }
};
